import Link from 'next/link';
import { CONFIG } from '@frameio/config';
import { MenuButton } from '@frameio/vapor';
import { IconGlobe } from '@frameio/vapor-icons';
import TEXT from './generated/TEXT/MarketingWebsiteMenuItem';

TEXT.DEFINE({
  /** Menu item label that opens the Frame.io marketing website in a new tab */
  homePage: 'Frame.io',
});

export function MarketingWebsiteMenuItem() {
  return (
    <Link href={CONFIG.marketingSiteUrl} target="_blank">
      <MenuButton iconBefore={<IconGlobe />} isLink={false}>
        {TEXT.homePage}
      </MenuButton>
    </Link>
  );
}
